import { IApiComponent } from './IApiComponent';
import { BrowserDetector } from "../tools/BrowserDetector";

export class ApiComponent implements IApiComponent
{
    isBotViewing() : boolean {
        return BrowserDetector.isBot();
    }
}